import React, { Fragment, useState } from 'react';

import { useOrderContext } from 'hooks';
import { PaymentDetailsViewProps } from 'types';

import { RosaOneHeader } from '../RosaOneHeader';
import { RosaOneInstructionWrapper } from '../RosaOneInstructionWrapper';
import { RosaOneRequisitesDetails } from '../RosaOneRequisitesDetails';

export type MobileStep = 'save' | 'pay' | 'gallery';

export const RosaOnePaymentDetails: React.FC<PaymentDetailsViewProps> = ({
  actions,
}) => {
  const { order, status } = useOrderContext();

  const confirmAction = actions[actions.length - 1];
  const [mobileStep, setMobileStep] = useState<MobileStep>('save');

  return (
    <Fragment>
      <RosaOneHeader shopName={order.shop?.name ?? ''} status={status} />
      <div className="tw-flex tw-flex-col md:tw-flex-row tw-gap-4 md:tw-gap-12 md:tw-items-center tw-w-full">
        <RosaOneInstructionWrapper
          mobileStep={mobileStep}
          className="md:tw-flex-1"
        />
        <RosaOneRequisitesDetails
          confirmAction={confirmAction}
          onStepChange={setMobileStep}
          className="md:tw-flex-1"
        />
      </div>
    </Fragment>
  );
};
